/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-07-24 16:15:49
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import scroll from 'vue-seamless-scroll'
// import 'element-ui/lib/theme-chalk/index.css'
import '../theme/index.css'
import './assets/icon/iconfont.css'
import 'font-awesome/css/font-awesome.css'
import './assets/style.css'
import tagCloud from '../src/components/tagCloud'
import 'animate.css'
// 兼容ie9+
import 'babel-polyfill'
import md5 from 'js-md5'
// permisson
import './permission.js'
import './assets/style/style.scss'
if (process.env.MOCK) {
  require('./mocks')
}
import moment from 'moment'
Vue.prototype.$moment = moment

Vue.use(scroll)
Vue.use(tagCloud)
Vue.use(ElementUI)
Vue.prototype.$md5 = md5
export const event = new Vue()

console.log('version:1.1')

Vue.config.productionTip = false

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})

Vue.directive('enterNumber', {
  inserted: function (el) {
    var fun = function (e) {
      e = e || window.event
      let charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode
      let re = /\d/
      if (
        !re.test(String.fromCharCode(charcode)) &&
        charcode > 9 &&
        !e.ctrlKey
      ) {
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.returnValue = false
        }
      }
    }
    el.addEventListener('keypress', function (e) {
      fun(e)
    })
    el.addEventListener('keyup', function (e) {
      if (/^[0-9]+$/.test(el.value)) {
        fun(e)
      } else {
        el.value = ''
      }
    })
    el.addEventListener('compositionstart', function (e) {
      el.value = ''
      el.blur()
    })
    el.addEventListener('compositionupdate', function (e) {
      el.value = ''
      el.blur()
    })
    el.addEventListener('compositionend', function (e) {
      el.value = ''
      el.blur()
    })
  }
})

export default app



// WEBPACK FOOTER //
// ./src/main.js